import script from "./ModelComparisonList.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelComparisonList.vue?vue&type=script&setup=true&lang=js"

import "./ModelComparisonList.vue?vue&type=style&index=0&id=c824e2b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c824e2b4"]])

export default __exports__